import "./css/homeMenu.css"
import { Link, useNavigate } from "react-router-dom"
import { useState, useEffect, useRef } from "react"

const HomeMenu = () => {
    const [toggleProfileMenu, setToggleProfileMenu] = useState(false)
    const [toggleMainMenu, setToggleMainMenu] = useState(false)
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024)
    const [isScrolled, setIsScrolled] = useState(false)
    const profileRef = useRef(null)
    const menuRef = useRef(null)
    const navigate = useNavigate()
    const userToken = localStorage.getItem("token")

    const toggleMenu = () => {
        setToggleMainMenu(!toggleMainMenu)
    }

    const handleLogout = () => {
        localStorage.clear()
        navigate("/")
        window.location.reload()
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (profileRef.current && !profileRef.current.contains(e.target)) {
                setToggleProfileMenu(false)
            }
            if (menuRef.current && !menuRef.current.contains(e.target) && isMobile) {
                setToggleMainMenu(false)
            }
        }
        document.addEventListener("click", handleClickOutside)
        return () => document.removeEventListener("click", handleClickOutside)
    }, [isMobile])

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 1024)
            if (window.innerWidth > 1024) {
                setToggleMainMenu(false)
            }
        }
        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10)
        }
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    const navItems = [
        { path: "/", label: "Home" },
        { path: "/test", label: "Test" },
        { path: "/course", label: "Course" },
        { path: "/apply", label: "Apply" },
        { path: "/app", label: "App" },
    ]

    return (
        <header className={`homeMenuWrapper ${isScrolled ? 'scrolled' : ''}`} ref={menuRef}>
            <div className="homeMenuContainer">
                
                {/* Logo Section */}
                <div className="homeMenuLogoContainer">
                    <Link to="/" className="homeMenuLogo">
                        <span className="logoText">
                            {process.env.REACT_APP_APP_NAME || "ExamPrep"}
                        </span>
                    </Link>
                </div>

                {/* Mobile Hamburger Toggle */}
                {isMobile && (
                    <div className="mobileMenuToggle" onClick={toggleMenu}>
                        <div className={`hamburger ${toggleMainMenu ? 'active' : ''}`}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                )}

                {/* Navigation Links */}
                <nav className={`homeMenuNav ${toggleMainMenu ? 'active' : ''}`}>
                    <ul className="navMenu">
                        {navItems.map((item, index) => (
                            <li key={index} className="navItem">
                                <Link 
                                    to={item.path} 
                                    className="navLink"
                                    onClick={() => isMobile && setToggleMainMenu(false)}
                                >
                                    <span className="navLabel">{item.label}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                {/* Authentication / Profile Section */}
                <div className={`homeMenuAuth ${toggleMainMenu ? 'active' : ''}`} ref={profileRef}>
                    {!userToken ? (
                        <div className="authButtons">
                            <Link to="/login" className="authButton loginButton">
                                <span>Login</span>
                            </Link>
                            <Link to="/signup" className="authButton signupButton">
                                <span>Sign Up</span>
                            </Link>
                        </div>
                    ) : (
                        <div className="userProfile">
                            <div 
                                className="profileToggle"
                                onClick={() => setToggleProfileMenu(!toggleProfileMenu)}
                            >
                                <div className="profileAvatar">
                                    <span>U</span>
                                </div>
                                <span className="profileName">Profile</span>
                                <span className="dropdownArrow">{toggleProfileMenu ? '▲' : '▼'}</span>
                            </div>
                            
                            {toggleProfileMenu && (
                                <div className="profileDropdown">
                                    <div className="dropdownContent">
                                        <Link 
                                            to="/profile" 
                                            className="dropdownItem"
                                            onClick={() => setToggleProfileMenu(false)}
                                        >
                                            <span>My Profile</span>
                                        </Link>                                    
                                        <div className="dropdownDivider"></div>
                                        <button 
                                            className="dropdownItem logoutButton"
                                            onClick={handleLogout}
                                        >
                                            <span>Logout</span>
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </header>
    )
}

export default HomeMenu